import React from 'react'

const ProductError = ({error}) => (
    <div style={{paddingTop: '40px', textAlign: 'center'}} >
        <h3>{error}</h3>
    </div>
)

export default ProductError
